<template>
	<div class="indexbg">
		<topbar></topbar>
		<header></header>
		<emallheader></emallheader>
		<div class="clear mt15"></div>

		<div class="w1200 bc">
			<!--购物车：开始-->
			<div class="hq-shopping-cart">
				<!--购物流程：开始-->
				<div class="hq-reg-step">
					<ul class="ico">
						<li>
							<p class="item">shopping cart</p>
							<i class="step-count"></i>
						</li>
						<li><span class="line"></span></li>
						<li class="active">
							<p class="item">submit orders</p>
							<i class="step-count"></i>
						</li>
						<li><span class="line"></span></li>
						<li>
							<p class="item">confirm payment</p>
							<i class="step-count"></i>
						</li>
						<li><span class="line"></span></li>
						<li>
							<p class="item">successfully ordered</p>
							<i class="step-count"></i>
						</li>
					</ul>
				</div>
				<!--购物流程：结束-->
				<!--确认收货地址：开始-->
				<div class="bd-box fill-address">
					<div class="hd-title clear-l">
						<!--<a class="co-b-2 f12 fr" @click="editAddress()">管理收货地址</a>-->
						<h4 class="">Confirm your delivery address</h4>
					</div>
					<dt class="dt-jsz">sent to</dt>
					<div v-for="(addressBo,index) in addressBoList">
					<dl class="active dl-active" name="addressNode" v-bind:id="'dl_'+addressBo.id" style="color:#666">
						<dd>
							<a class="co-b-2 edit-addr fr" @click="editAddress(addressBo.id)">Modify this address</a>
							<input name="addressChk" type="radio" :value="addressBo.id" @click="chooseAddress(addressBo.id,index)" :checked="addressBo.id==addressId">
							<span class="addr">{{addressBo.province}} {{ addressBo.city }} {{ addressBo.district }} {{addressBo.address}}（{{ addressBo.contextName }} 收）</span>
							<span class="tel">{{ addressBo.mobile }}</span>
							<input type="hidden" id="addressId" v-bind:value="addressBo.contextName" />
						</dd>
					</dl>
					</div>
					<div v-if="canCreateAddress" class="ft-add-addr">
						<a @click="addAddress()" class="co-b-2 add-addr"><i>+</i>Use the new address</a>
					</div>
				</div>
				<!--确认收货地址：结束-->
				<!--发票：开始 暂时屏蔽-->
				<!--<div class="fapiao mt20">
					<div class="step-tit" id="invoice-step">
						<h3>发票信息</h3>
						<div class="tips-new-white">
							<b></b><span><i></i>开企业抬头发票须填写纳税人识别号，以免影响报销</span>
						</div>
					</div>
					<div class="step-content">
						<div id="part-inv" class="invoice-cont">
							<div id="part-inv" class="invoice-cont">
								<span class="mr10" id="receiptSmall1"> {{receiptSmall1}}  &nbsp; </span>
								<span class="mr10" id="receiptSmall2" style="display: none;"> {{receiptSmall2}} &nbsp; </span>
								<span class="mr10" id="receiptSmall3" style="display: none;"> {{receiptSmall3}} &nbsp; </span> &nbsp;
								<a class="ftx-05 invoice-edit" id="xiugai" @click="showmodal">修改</a>
							</div>
						</div>
					</div>
				</div>-->
				<!--发票：结束-->
				<!-- 附件商家地图开始 -->
				<div id="nearbyCompanyMap" class="bd-box fill-ordering mt20">
					<div class="hd-title-2">
						<h4 class="">Nearby businesses</h4>
					</div>
					<!--地图容器-->
					<div id="mapPage" class="mapPage" ></div>
				</div>
				<!-- 附件商家地图结束 -->
				<!--确认订单信息：开始-->
				<div class="bd-box fill-ordering mt20">
					<div class="hd-title-2">
						<h4 class="">Confirm Order Information</h4>
					</div>
					<div class="hd">
						<dl>
							<dt class="col-1"><span class="ml20"><!--Store: US Group Intellectual Property Official Flagship Store-->Product Name</span></dt>
							<dt class="col-2">Delivery method</dt>
							<dt class="col-3">Unit price</dt>
							<dt class="col-4">service fee</dt>
							<dt class="col-5">quantity</dt>
							<dt class="col-6">Total price</dt>
						</dl>
					</div>
					<div class="bd">
						<div  v-for="(shop,index) in shopBoList" class="items">
						    <!--<div class="shop-name" >
								Shop：{{shop.shopName}}
							</div>-->
							<dl v-for="bo in shop.boListIn">
								<!-- {{bo}} -->
								<dd class="col-1">
									<img class="fl" v-bind:src="bo.imgSmall" width="75" height="75">
									<a class="co-b-2 name" v-on:click="toDetail(bo.goodsCode)">{{ bo.goodsNameEn }}</a>
									<span v-if="bo.specNameEn">【{{bo.specNameEn}}】</span>
										<span v-if="bo.seven_day_return=='Y'||bo.sevenDayReturn=='Y'" class="co-b-2 name" style="padding-top: 10px;"><i class="ico-sp-tk"></i>Support 7 days no reason to return service</span>
								</dd>
								<dd  class="col-2 sp-meta">
									<span v-for="typeItem in bo.deliveryTypeArray" v-if="typeItem != null&&typeItem != ''"  @click="chooseDeliveryType(typeItem.typeCode,bo)" :class="{selected: typeItem.typeCode == bo.deliveryType}" class="td-txt">{{ typeItem.typeName }}</span>
								</dd>
								<!--<dd class="col-3 co4">￥{{ bo.unitPrice }}</dd>-->
								<!-- -->
								<dd v-if="bo.unitPrice > 0 && bo.goodsPrice == 0" class="col-3 co4">￥{{ bo.unitPrice }}</dd>
								<dd v-else-if="bo.unitPrice == 0 && bo.goodsPrice > 0"  class="col-3 co4">{{ bo.goodsPrice }}
									<span v-if="bo.pointType == 'point'">point</span>
									<span v-else-if="bo.pointType == 'special'">special point</span>
									<span v-else-if="bo.pointType == 'red'">red point</span>
									<span v-else-if="bo.pointType == 'blue'">blue point</span>
								</dd>
								<dd v-else-if="bo.unitPrice > 0 && bo.goodsPrice > 0"  class="col-3 co4">
									￥{{ bo.unitPrice }} + {{ bo.goodsPrice }}
									<span v-if="bo.pointType == 'point'">point</span>
									<span v-else-if="bo.pointType == 'special'">special point</span>
									<span v-else-if="bo.pointType == 'red'">red point</span>
									<span v-else-if="bo.pointType == 'blue'">blue point</span>
								</dd>
								<dd class="col-4 co4">
									￥{{ (printServicePara+rebrandingServicePara+printingServicePara+laserServicePara)/100 }}
								</dd>
								<!-- -->
								<dd class="col-5 co4" name="number" >{{ bo.goodsNumber }}</dd>
								<!--<dd class="col-5 co-r-1 f14" name="unitPrice">￥{{ bo.ext1 }}</dd>-->
								<!--<dd class="col-5 co-r-1 f14" name="unitPrice">￥{{ (bo.unitPrice*bo.goodsNumber).toFixed(2) }}</dd>-->
								<!-- -->
								<dd class="col-6 co-r-1 f14">
									<span name="unitPrice" v-if="bo.unitPrice > 0">
										￥{{ ((bo.unitPrice+(printServicePara+rebrandingServicePara+printingServicePara+laserServicePara)/100)*bo.goodsNumber).toFixed(2) }}
									</span>
									<span v-if="bo.unitPrice > 0 && bo.goodsPrice > 0">
										+
									</span>
									<span name="goodsPrice" v-if="bo.goodsPrice > 0">
										{{ (bo.goodsPrice*bo.goodsNumber) }}
										<span v-if="bo.pointType == 'point'">point</span>
										<span v-else-if="bo.pointType == 'special'">special point</span>
										<span v-else-if="bo.pointType == 'red'">red point</span>
										<span v-else-if="bo.pointType == 'blue'">blue point</span>
									</span>
								</dd>
								<!-- -->
								<!-- -->
							</dl>
						    <div v-if="shop.expressFee>0&&goodsBo.deliveryType!='self_take'" class="hd" style="background: #f9f8fa;height: 30px;line-height: 30px;" >
								<dl>
									<dt class="col-1" style="visibility: hidden"><span class="ml20"><!--店铺：美的集团知识产权官方旗舰店-->Product Name</span></dt>
									<dt class="col-3" style="visibility: hidden">Price</dt>
									<dt class="col-4" style="visibility: hidden">Quantity</dt>
									<dt class="col-2" style="visibility: hidden">Service fee</dt>
									<!--<dt class="col-4" style="visibility: hidden"></dt>-->
									<dt  class="col-5" style="color: #e3101e">postage：￥{{(shop.expressFee/100).toFixed(2) }}</dt>
								</dl>
							</div>
					</div>
						<div class="total tr co5">
							selected<span class="m10">{{ sumCount }}</span>goods total：
							<span class="co-o-1 f18" v-if="goodsTotalPrice.totalPoint>0">{{ goodsTotalPrice.totalPoint }}point<span v-if="sumOrderAmount>0">+</span></span>
							<span class="co-o-1 f18" v-if="goodsTotalPrice.totalRed>0">{{ goodsTotalPrice.totalRed }}red point+</span>
							<span class="co-o-1 f18" v-if="goodsTotalPrice.totalBlue>0">{{ goodsTotalPrice.totalBlue }}blue point+</span>
							<span class="co-o-1 f18" v-if="goodsTotalPrice.totalSpecial>0">{{ goodsTotalPrice.totalSpecial }}special point+</span>
							<span class="co-o-1 f18" v-if="usableCouponList!=''"><span v-if="sumOrderAmount>0">￥{{(sumOrderAmount).toFixed(2)}}</span><span v-if="totalExpressAmount>0&&goodsBo.deliveryType!='self_take'">+￥{{(totalExpressAmount/100).toFixed(2) }}</span><span v-if="couponDiscountAmount>0">-￥{{(couponDiscountAmount/100).toFixed(2)}}</span></span>
							<span class="co-o-1 f18" v-else><span v-if="sumOrderAmount>0">￥{{(sumOrderAmount).toFixed(2)}}</span><span v-if="totalExpressAmount>0&&goodsBo.deliveryType!='self_take'">+￥{{(totalExpressAmount/100).toFixed(2) }}</span></span>
							<br>

							<!--<span v-if="totalExpressAmount>0">运费：</span><span v-if="totalExpressAmount>0" class="co-o-1 f18">+￥{{(totalExpressAmount/100).toFixed(2) }}</span>
							<br>-->
							<span v-if="brokerDiscountAmount>0&&discountType=='broker_level'">Member discount：</span><span v-if="brokerDiscountAmount>0&&discountType=='broker_level'" class="co-o-1 f18">-￥{{(brokerDiscountAmount/100).toFixed(2) }}</span>

							<p class="mt15" v-if="orderSource=='cart'">
								<router-link :to="{path:'/shopCart'}" class="co-b-1 f14" href="#">Return to shopping cart></router-link>
							</p>
							<!--</div>-->
						</div>
						<div class="total tr co5"  v-for="(pointBo,index) in points" v-if="pointBo.discountMoney>0&&seckillPrice==''">
							<span style="line-height:1.5rem;">use
									{{pointBo.usableNum}}Point credit
									￥{{pointBo.discountMoney}}</span>
								<div style="float:right;" class="mui-left mui-ellipsis">
									<input v-model="pointBo.is_choosed" type="checkbox" v-on:click="chkDiscount()">
								</div>
						</div>
					</div>
				</div>
				<div class="fill-ordering-ft">
					Total order consumption：
					<span class="f20 co2" v-if="discountType=='point'&&(pointNum+goodsTotalPrice.totalPoint)>0">{{ pointNum+goodsTotalPrice.totalPoint }}point<span v-if="sumAmount>0">+</span></span>
					<span class="f20 co2" v-else-if="discountType!='point'&&goodsTotalPrice.totalPoint>0">{{ goodsTotalPrice.totalPoint }}point<span v-if="sumAmount>0">+</span></span>

					<span class="f20 co2" v-if="goodsTotalPrice.totalRed>0">{{ goodsTotalPrice.totalRed }}red point<span v-if="sumAmount>0">+</span></span>
					<span class="f20 co2" v-if="goodsTotalPrice.totalBlue>0">{{ goodsTotalPrice.totalBlue }}blue point<span v-if="sumAmount>0">+</span></span>
					<span class="f20 co2" v-if="goodsTotalPrice.totalSpecial>0">{{ goodsTotalPrice.totalSpecial }}special point<span v-if="sumAmount>0">+</span></span>
					<span class="f20 co2" v-if="goodsBo.deliveryType=='self_take'&&(sumOrderAmount-discountAmount)>0">¥{{ (sumOrderAmount-discountAmount).toFixed(2) }}</span>
					<span class="f20 co2" v-else-if="goodsBo.deliveryType!='self_take'&&(sumOrderAmount-discountAmount+totalExpressAmount/100)>0">¥{{ (sumOrderAmount-discountAmount+totalExpressAmount/100).toFixed(2) }}</span>
					<a class="a-btn-submit ml20" v-on:click="submitOrderExt()">Submit</a>
				</div>
				<!--确认订单信息：结束-->

			</div>
			<!--购物车：结束-->

			<div class="clear"></div>
			<div class="mb20 ad-4 mt20"><img src="../../../static/images/footer-ad-1.png" width="1200" height="60"></div>
			<!-- 发票弹出开始  -->
			<div class="ui-mask" style="display: none;"></div>
			<div class="ui-dialog" id="mainId" style="display: none;">
				<div class="ui-dialog-title">
					<span>Invoice Information</span>
				</div>
				<div class="ui-dialog-content">
					<div class="invoice-dialog" id="invoice-tab">
						<div class="tab-nav">
							<ul>
								<!--<li id="click_1" class="tab-nav-item  hide" value="1" clstag="pageclick|keycount|trade_201602181|17">普通发票<b></b></li>-->
								<li id="click_2" class="tab-nav-item tab-item-selected" @click="change2()">企业发票<b></b></li>
								<li id="click_3" class="tab-nav-item" @click="change3()">增值税专用发票<b></b></li>
							</ul>
						</div>
						<div class="tab-con ui-switchable-panel-selected" id="ele-inv" style="display: block;">
							<div class="form">
								<div id="electro-invoice-tips" class="invoice-tips ftx-03 mt10 mb10 ">
									<i></i>
									<span class="tip-cont">电子普通发票和纸质普通发票具备同等法律效力，可支持报销入账，京东自营全面启用电子普通发票，</span>
									<span class="tip-cont ml30">非京东自营发票由第三方商家实际开具。<a target="_blank" class="ftx-05" href="//help.jd.com/user/issue/list-505-508.html">电子普通发票相关信息&gt;&gt;</a></span>
									<span class="tip-cont ml30">如商品由第三方卖家销售，发票类型及内容将由该卖家决定。<a target="_blank" class="ftx-05" href="//help.jd.com/user/issue/list-505-508.html">发票信息相关问题&gt;&gt;</a></span>
								</div>
								<input type="hidden" id="invoice_ceshi1" name="invoice_ceshi1" value="">
								<div class="item">
									<span class="label">发票抬头</span>
									<div class="fl">
										<div class="invoice-list invoice-tit-list" id="invoice-tit-list_lest">
											<div class="invoice-item rise invoice-item-selected" style="cursor:pointer" @click="selectTitle($event,'-1','')">
												<div id="invoice-2" style="cursor:pointer">
													<span class="hide"><input type="hidden" value="4"></span>
													<span class="fore2">
													<input type="text" style="cursor:pointer" class="itxt" id="fff" value="个人" readonly="true" ><b></b></span>
												</div>
											</div>
											<div class="invoice-item rise" style="cursor:pointer;" @click="selectTitle($event,enterprise.id,enterprise.taxpayerNum)" v-for="enterprise in enterpriseList">
												<div id="invoice-2" style="cursor:pointer">
													<input type="text" style="cursor:pointer" class="itxt" id="fff" :value="enterprise.receiptTitle" readonly="true"><b></b></span>
												</div>
											</div>
											<div class="invoice-item rise" style="cursor:pointer;display: none;" @click="selectTitle($event,'0','')" id="newReceiptTitle">
												<div id="invoice-2" style="cursor:pointer">
													<span class="hide"><input type="hidden" value="5"></span>
													<input type="text" class="itxt itxt04" placeholder="请填写公司发票抬头"><b></b>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="item nor-inv-type0" id="addEnterpriseRecipes" @click="addEnterprise()">
									<span class="label"></span>
									<div class="fl">
										<a class="ftx-05">新增企业发票</a>
									</div>
								</div>
								<div class="item nor-inv-type0" id="ele_code_div" style="display: none;">
									<span class="label">纳税人识别号</span>
									<div class="fl">
										<input type="text" class="itxt itxt05" placeholder="纳税人识别号" name="ele_code" id="ele_code" value="">
									</div>
								</div>
								<div class="item invoice_content">
									<span class="label">发票内容</span>
									<div class="fl">
										<div class="invoice-list">
											<ul id="electro_book_content_radio">
												<li class="invoice-item invoice-item-selected" id="electro-invoice-content-1" style="cursor:pointer" @click="contentTab1">
													不开发票<b></b>
												</li>
												<li class="invoice-item" @click="contentTab2" id="electro-invoice-content-2" name="electro-normalContent" value="1" data-desc="发票内容将显示详细商品名称与价格信息" style="cursor:pointer">
													商品明细<b></b>
												</li>
											</ul>
											<span class="ftx03" id="receiptContent" style="display: none;">
							        <i class="warn-icon"></i>发票内容将显示详细商品名称与价格信息
											</span>
										</div>
									</div>
								</div>

								<div class="item">
									<span class="label">&nbsp;</span>
									<div class="fl">
										<div class="op-btns">
											<a class="btn-1" @click="saveReceipt()">保存</a>
											<a class="btn-9 ml10" @click="closemodal()">取消</a>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="tab-con" id="vat-inv" style="display: none;">
							<div id="vat-invoice-tips" class="invoice-tips ftx-03 mt10 mb10 ">
								<i></i>
								<span class="tip-cont">我司依法开具发票，请您按照税法规定使用发票。</span>
								<!--<span class="tip-cont ml30 ftx-05">
					 			<a href="//help.jd.com/user/issue/502-974.html" target="_blank" class="ftx-05">发票制度说明&gt;&gt;</a>
							    <a href="//help.jd.com/user/issue/list-505-509.html" target="_blank" class="ftx-05">首次开具增值税专用发票&gt;&gt;</a>
								</span>
								<span class="tip-cont ml30">如商品由第三方卖家销售，发票类型和内容将由该卖家决定，发票由卖家开具并提供。<a target="_blank" class="ftx-05" href="//help.jd.com/user/issue/list-505-509.html">发票信息相关问题&gt;&gt;</a></span>-->

							</div>
							<div class="form" id="invoice-box-03">
								<div class="steps">
									<div class="item">
										<span class="label">单位名称</span>
										<div class="fl">
											<div class="invoice-list invoice-tit-list zy" id="invoice-tit-list_lest1">
												<div class="invoice-item rise1 invoice-item-selected" style="cursor:pointer" @click="selectTitle1($event,'-1','')">
													<div id="invoice-2" style="cursor:pointer">
														<span class="hide"><input type="hidden" value="4"></span>
														<span class="fore2">
													<input type="text" style="cursor:pointer" class="itxt" id="fff" value="不开发票" readonly="true" ><b></b></span>
													</div>
												</div>
												<div class="invoice-item rise1" style="cursor:pointer;" v-for="special in specialList" @click="selectTitle1($event,special.id,special.taxpayerNum,special.address,special.phone,special.openBank,special.openBankAccount)">
													<div id="invoice-2" style="cursor:pointer">
														<input type="text" style="cursor:pointer" class="itxt" id="fff" :value="special.receiptTitle" readonly="true"><b></b></span>
													</div>
												</div>
												<div class="invoice-item rise1" style="cursor:pointer;display: none;" @click="selectTitle1($event,'0','')" id="newReceiptTitle1">
													<div id="invoice-2" style="cursor:pointer">
														<span class="hide"><input type="hidden" value="5"></span>
													<input type="text" class="itxt itxt04" placeholder="请填写单位名称"><b></b>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="item nor-inv-type0" id="addEnterpriseRecipes1" @click="addEnterprise1()">
										<span class="label"></span>
										<div class="fl">
											<a class="ftx-05">新增企业发票</a>
										</div>
									</div>
									<div id="vat-inv-type1" class="step vat-inv-type0 vat-inv-type1" style="display: none;">
										<input type="hidden" id="vatCanEdit" value="false">
										<!--<div class="item">
											<span class="label" id="vat_companyName_div"><em class="required">*</em>单位名称</span>
											<div class="fl">
												<input type="text" class="itxt itxt04 vat-step-1" name="vat_companyName" id="vat_companyName" value="" onblur="check_Invoice('vat_companyName', this.value)">
												<span class="message error-msg" id="vat_companyName_error">单位名称不能为空！</span>
											</div>
										</div>-->
										<div class="item" id="vat_code_div">
											<span class="label"><em class="required">*</em>纳税人识别码</span>
											<div class="fl">
												<input type="text" class="itxt itxt04 vat-step-1" name="vat_code" id="vat_code" value="" @blur="check_Invoice('vat_code', $event)" @change="check_Invoice('vat_code', $event)">
												<span class="message " id="vat_code_error"></span>
											</div>
										</div>
										<div class="item" id="vat_address_div">
											<span class="label"><em class="required">*</em>注册地址</span>
											<div class="fl">
												<input type="text" class="itxt itxt04 vat-step-1" name="vat_address" id="vat_address" value="" @blur="check_Invoice('vat_address', $event)" @change="check_Invoice('vat_address', $event)">
												<span class="message " id="vat_address_error"></span>
											</div>
										</div>
										<div class="item" id="vat_phone_div">
											<span class="label"><em class="required">*</em>注册电话</span>
											<div class="fl">
												<input type="text" class="itxt itxt04 vat-step-1" name="vat_phone" id="vat_phone" value="" @blur="check_Invoice('vat_phone', $event)" @change="check_Invoice('vat_phone', $event)">
												<span class="message " id="vat_phone_error"></span>
											</div>
										</div>
										<div class="item" id="vat_bankName_div">
											<span class="label"><em class="required">*</em>开户银行</span>
											<div class="fl">
												<input type="text" class="itxt itxt04 vat-step-1" name="vat_bankName" id="vat_bankName" value="" @blur="check_Invoice('vat_bankName', $event)" @change="check_Invoice('vat_bankName', $event)">
												<span class="message " id="vat_bankName_error"></span>
											</div>
										</div>
										<div class="item" id="vat_bankAccount_div">
											<span class="label"><em class="required">*</em>银行账户</span>
											<div class="fl">
												<input type="text" class="itxt itxt04 vat-step-1" name="vat_bankAccount" id="vat_bankAccount" value="" @blur="check_Invoice('vat_bankAccount', $event)" @change="check_Invoice('vat_bankAccount', $event)">
												<span class="message " id="vat_bankAccount_error"></span>
											</div>
										</div>

									</div>
									<div class="item">
										<span class="label"></span>
										<div class="fl">
											<div class="op-btns">
												<a id="vat-btn-save" type="button" class="btn-1" @click="saveReceipt1()">保存</a>
												<a class="btn-9 ml10" @click="closemodal()">取消</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<a class="ui-dialog-close" title="关闭" @click="closemodal()">
					<span class="ui-icon ui-icon-delete">				
		</span>
				</a>
			</div>
			<!-- 发票弹出结束 -->
		</div>
		<!--container 结束-->
		<div class="clear"></div>
		<footermenu></footermenu>
		<footercopyright></footercopyright>

	</div>
</template>

<script>
	import TopBar from '@/components/TopBar'
	import EmallHeader from '@/components/Header'
	import FooterMenu from '@/components/FooterMenu'
	import ShopNav from '@/components/ShopNav'
	import FooterCopyright from '@/components/FooterCopyright'
	import API from "../../../static/api/api.js"
	import { getImgUrl, dateFormat, getValueFromMap, showMoney, parseResult,ak} from "../../../static/js/emallUtils.js"
	import alertConfirm from "../../../static/js/alertConfirm.js"
	import Vue from 'vue'
	import VueRouter from 'vue-router'
	import {MP} from '../../../static/js/map.js'
	Vue.use(VueRouter)

	export default {
		name: 'ordercommit',
		data() {
			return {
            	couponCode: '', //优惠券编码
            	couponSubCode: '', //用户优惠券编码
				discountType: '', //抵扣类型：优惠券、会员折扣、积分
				discountAmount: 0,
				brokerDiscountAmount: 0, //代理商折扣金额
				couponDiscountAmount: 0,//优惠券折扣金额
				boList: [],
				shopBoList:[],
				addressBoList: [],
				address:'',
				addressId:0,
				canCreateAddress: true,
				sumCount: 0,
				sumAmount: 0,
				sumOrderAmount: 0,
				totalExpressAmount: 0,
				isOnline: true,
				goodsBo:'',
				orderSource:'',
				distributeAccount:'',
				distributeName:'',
				brokerDiscountPersent:0,
				brokerDiscountAmount:0,
				goodsCode:'',
				shopCode:'',
				shopName:'',
				shopNameEn:'',
				payNum:0,
				specName:'',
				specNameEn:'',
				usableCouponList: [], //可用优惠券列表,
            	goodsTotalPrice:{
					allAmount: 0,
					totalPoint: 0,
					totalRed: 0,
					totalBlue: 0,
					totalSpecial: 0,
					totalMoney: 0,
					totalExpressAmount: 0,
					brokerDiscountPersent: 0
				},
				map:{},
            	pointStr:'',
            	deliveryTypeFag:0,
            	indexFag:0,
            	seckillPrice:'',
            	pointNum:0,//可使用的抵扣积分数量
            	pointDiscount:0,//积分抵扣金额（分）
            	points:[],
				receiptType: 1,
				isReceipt: 0,
				enterpriseList: [],
				specialList: [],
				taxpayerNum: '',
				receiptTitle: '',
				receiptId: 0,
				receiptSmall1: '不开发票',
				receiptSmall2: '',
				receiptSmall3: '',
				isReceipt1: 0,
				receiptId1: 0,
				receiptflag: false,
				isReceiptTrue: 0,
				serviceAmount:0,//服务费累计
				printServicePara:0,
				rebrandingServicePara:0,
				printingServicePara:0,
				laserServicePara:0,
				fileNamePara:null,
				filePathPara:null,
				imageNamePara:null,
				imagePathPara:null,
				orderType:'spot'//订单类型，默认为现货

			}
		},
		components: {
			'topbar': TopBar,
			'emallheader': EmallHeader,
			'footermenu': FooterMenu,
			'footercopyright': FooterCopyright,
		},
		methods: {
			//选择规则
        	chooseDeliveryType:function(typeItem,goodsBo){
        		var that = this;
        		goodsBo.deliveryType = typeItem;
        		if(typeItem=="self_take"&&that.addressId == 0){
              alertConfirm.singleConfirm("请先设置收货地址");
              return false;
            }else{
              this.showMap();
            }
            //计算运费
            that.computeExpressFee();
        	},
			addAddress:function(){
				this.$router.push({
					name: 'address',
					query: {
						backUrl:'orderCommit?specName='+this.specName,
						orderSource:this.orderSource,
						boList:this.boList,
						goodsCode:this.goodsCode,
						shopCode:this.shopCode,
						payNum:this.payNum,
						distributeAccount:this.distributeAccount,
						distributeName:this.distributeName
						}
					});
			},
			editAddress:function(addressId){
				this.$router.push({
					name:'address',
					query:{
						backUrl:'orderCommit',
						orderSource:this.orderSource,
						boList:this.boList,
						goodsCode:this.goodsCode,
						shopCode:this.shopCode,
						payNum:this.payNum,
						distributeAccount:this.distributeAccount,
						distributeName:this.distributeName,
					    addressId:addressId,
					    goodsCodes:""
					    }
					});
			},
			chooseAddress:function(addressId,index){
				$("dl[id^='dl_']").css("color","#666");
				//$("dl[id='dl_" +addressId+ "']").css("color","#fa660f");
				//alert(addressId);
				this.addressId=addressId;
				this.indexFag=index;
				var that = this;
				this.selectAddressPoint();
				//计算运费
				that.computeExpressFee();
			},

			getSumCount: function() {
				var that = this;
				var count = 0;
				jQuery("[name='number']").each(function() {
					var num = jQuery(this).text();
					count = count + parseInt(num);
				})
				that.sumCount = count;
			},
			getSumAmount: function() {
				var that = this;
				var amount = 0;
				jQuery("[name='unitPrice']").each(function() {
					var price = jQuery(this).text().replace("￥", "");
					amount = amount + parseFloat(price);
				})
				that.sumOrderAmount = amount;
					if(that.brokerDiscountPersent!=0&&(that.seckillPrice==undefined||that.seckillPrice=='')){
						that.brokerDiscountAmount=that.sumOrderAmount*(100-that.brokerDiscountPersent);
						that.sumAmount = amount*that.brokerDiscountPersent/100+that.totalExpressAmount/100;
					}else{
						that.sumAmount = amount+that.totalExpressAmount/100
					}
			},
			toDetail: function(goodsCode) {
				this.$router.push({name: 'goodsdetail',query: {goodsCode: goodsCode}});
			},
			getUserAddresses: function() {
				var that = this;
				API.queryUserAddress(function(ret) {
					if(ret.data!= undefined){
						that.addressBoList = ret.data;
						if(that.addressBoList!=null&&that.addressBoList.length>0){
							that.addressBoList[0].isDefault='y';
							that.address=that.addressBoList[0];
							that.addressId=that.addressBoList[0].id;
						}
						if(that.addressBoList!=null&&that.addressBoList.length>4){
							that.canCreateAddress=false;
						}
						that.getCart(that.addressId);
					}
					//计算运费
					that.computeExpressFee();
				})

			},
			getCart: function () {
				var that = this;
				API.getCartListByCode(that.goodsCodes, "", that.addressId, function (ret) {
					if (ret.data != null) {
						that.points = ret.data.points;
						that.pointNum=that.points.point.usableNum;
						that.pointDiscount=that.points.point.discountMoney;
					}
				});
			},
			//选择抵扣信息
			chkDiscount: function () {
				var that = this;
				setTimeout(function () {
				if (that.points.point.is_choosed) {
					that.discountAmount=that.points.point.discountMoney;
					that.discountType = "point";
				}else{
						if (that.brokerDiscountAmount > 0) {
							that.discountType = "broker_level";
							that.discountAmount = that.brokerDiscountAmount/100;
						} else {
							that.discountType = "";
							that.discountAmount = 0;
						}
				}
				}, 0)
			},
			submitOrderExt: function() {
				var that = this;
				if(that.addressId == 0){
					alertConfirm.singleConfirm("Please set the shipping address first.");
					return false;
				}
				var payNum = that.payNum;
				var buyerNote = "";
				var goodOrder = "";
				var orderSource = that.orderSource;
				if(orderSource != "noCart"){
					orderSource = "cart";
				}
				var bos = that.boList;
				for(var i=0;i<bos.length;i++){
					if(i>0){
						goodOrder+=",";
					}
					var specName=null;
					var specNameEn=null;
					var deliveryType=null;
          if(bos[i].specName!=undefined&&bos[i].specName!=''){
            specName=encodeURI(bos[i].specName);
          }
          if(bos[i].specNameEn!=undefined&&bos[i].specNameEn!=''){
            specNameEn=encodeURI(bos[i].specNameEn);
          }
          if(bos[i].deliveryType!=undefined&&bos[i].deliveryType!=''){
            deliveryType=bos[i].deliveryType;
          }else{
            deliveryType=null;
          }
          var isChoosePrint="N";//是否选择了打印服务
          if(that.printServicePara!=undefined&&that.printServicePara!=null&&that.printServicePara>0){
          	isChoosePrint="Y";
          }
          var isChooseLaser="N";//是否选择了打印服务
          var isChoosePrinting="N";//是否选择了打印服务
          var isChooseRebranding="N";//是否选择了打印服务
          if(that.rebrandingServicePara!=undefined&&that.rebrandingServicePara!=null&&that.rebrandingServicePara>0){
          	isChooseRebranding="Y";
          }
          if(that.printingServicePara!=undefined&&that.printingServicePara!=null&&that.printingServicePara>0){
          	isChoosePrinting="Y";
          }
          if(that.laserServicePara!=undefined&&that.laserServicePara!=null&&that.laserServicePara>0){
          	isChooseLaser="Y";
          }
					if(bos[i].ext2 =="noCart"){	//
						bos[i].shopCode = bos[i].ext3;
						goodOrder = bos[i].goodsCode+":"+bos[i].goodsNumber+":"+bos[i].shopCode+":"+specName+":"+deliveryType+":"+bos[i].sevenDayReturn+":"+isChoosePrint+":"+isChooseLaser+":"+isChoosePrinting+":"+isChooseRebranding+":"+that.fileNamePara+":"+that.filePathPara+":"+that.imageNamePara+":"+that.imagePathPara;
					}else{
						goodOrder += bos[i].goodsCode+":"+bos[i].goodsNumber+":"+bos[i].id+":"+bos[i].shopCode+":"+specName+":"+deliveryType+":"+bos[i].seven_day_return;
					}
				}
				buyerNote = encodeURI(buyerNote);
				var isOnline = false;
				if(that.sumAmount>0){
					isOnline = true;
				}
				var addressId = that.addressId;
				var discountInfo = "";
				var distributeName =that.distributeName;
				var distributeAccount = that.distributeAccount;
				var discountType="";
				var totalPoint=0;
				if(that.discountType=="point"){
					discountInfo="point:"+that.pointNum+":"+that.pointDiscount;
					totalPoint=that.goodsTotalPrice.totalPoint+that.pointNum;
				}else{
					totalPoint=that.goodsTotalPrice.totalPoint+that.pointNum;
				}
				//
				var receiptTurn = 0;
				if(that.isReceiptTrue != 0) {
					if(that.receiptType == 1) {
						receiptTurn = -1;
					} else if(that.receiptType == 2) {
						receiptTurn = that.receiptId;
					} else if(that.receiptType == 3) {
						receiptTurn = that.receiptId1;
					}
				}
//				API.confirmOrder(goodOrder, null, buyerNote, isOnline, orderSource, function(ret) {
//				API.confirmPhysicalOrder(goodOrder,discountInfo,buyerNote,addressId,isOnline,couponCode,userAccount,profit,couponSubCode,orderSrc,function(ret){
				//alert(goodOrder);return false;
//现货订单
				API.confirmPhysicalOrder(that.orderType,goodOrder,discountInfo,buyerNote,addressId,isOnline,'','','','',orderSource,that.distributeName,that.distributeAccount,that.discountType,null,
				null,null,null,null,function(ret){
				var operation = '兑换';
					if(ret.code != null && ret.code == "success") {
						if(!isOnline){
							that.$router.push({ name: 'paySuccess', params:{}});
						}
						var tradeCode=ret.data.tradeCode;
						var packageCode=ret.data.packageCode;
						var totalAmount=that.sumOrderAmount-that.discountAmount;
						if(that.goodsBo.deliveryType!='self_take'){
							totalAmount+=that.totalExpressAmount/100;
						}
						that.$router.push({ name: 'orderconfirm', params:{
							bos:that.boList,
							sumAmount:totalAmount,
							totalPoint:totalPoint,
							tradeCode:tradeCode,
							packageCode:packageCode
						}});
					} else if(ret.code != null && ret.code == "online_success") {
						var tradeCode=ret.data.tradeCode;
						var packageCode=ret.data.packageCode;
						var totalAmount=that.sumOrderAmount-that.discountAmount;
						if(that.goodsBo.deliveryType!='self_take'){
							totalAmount+=that.totalExpressAmount/100;
						}
						that.$router.push({ name: 'orderconfirm', params:{
							bos:that.boList,
							sumAmount:totalAmount,
							totalPoint:totalPoint,
							tradeCode:tradeCode,
							orderList:ret.data.orderList,
							packageCode:packageCode
						}});
					}else if(ret.code != null && ret.code == "send_redirect") {
						window.location.href = ret.msg;
					} else if(ret.code == undefined || ret.code == null || ret.code == 'null') {
						alertConfirm.singleConfirm('The system is busy, please try again later');
					} else if(ret.code != null && ret.code == 'fail'){
						alertConfirm.singleConfirm(ret.msg);
					}else if(ret) {
						var errorCode = ret.code;
						var errorMsg = 'The system is busy, please try again later';
						if(errorCode == 'O_00001' || errorCode == 'O_00002' || errorCode == 'O_00011') {
							errorMsg = 'The product has not yet been sold';
						} else if(errorCode == 'O_00003') {
							errorMsg = 'The item is sold out';
						} else if(errorCode == 'O_00004') {
							errorMsg = 'Insufficient quantity of goods';
						} else if(errorCode == 'O_00005' || errorCode == 'O_00012') {
							errorMsg = operation + 'The amount has been used up';
						} else if(errorCode == 'O_00010') {
							errorMsg = 'Insufficient balance of points';
						} else if(errorCode == 'O_00019') {
							errorMsg = 'Your account is not' + operation + 'Within the range of the item';
						} else if(errorCode == 'U_00032') {
							errorMsg = 'Non-property users cannot purchase this item';
						}
						alertConfirm.singleConfirm(errorMsg);
					}
				});
			},
			getOrderConfirm:function(goodsCode,payNum,shopCode,shopName,shopNameEn,specName){
        		var that = this;
        		specName=encodeURI(specName);
        		API.getPhysicalOrderConfirm(goodsCode,payNum,specName,null,shopCode,function(ret){
        			if(ret.code == "success"){
        				that.address = ret.data.address;

        				/*if(ret.data.brokerDiscountPersent != undefined){
							that.brokerDiscountPersent=ret.data.brokerDiscountPersent;
						}*/
	        			that.goodsBo = ret.data.goods;
	        			that.goodsBo.attrValue = JSON.parse(ret.data.goods.attrValue);
	        			if(that.goodsBo.attrValue.deliveryType!=undefined&&that.goodsBo.attrValue.deliveryType!=''){
	        				var typeArray=new Array();
	        				if(that.goodsBo.attrValue.deliveryType.indexOf(",")==-1&&that.goodsBo.attrValue.deliveryType.indexOf("[")==-1){
	        					var deliveryObj={"typeCode":that.goodsBo.attrValue.deliveryType,"typeName":getValueFromMap(ret.data.enumDeliveryType,that.goodsBo.attrValue.deliveryType)};
	        					typeArray.push(deliveryObj);
	        					that.$set(that.goodsBo,'deliveryType',that.goodsBo.attrValue.deliveryType);
	        				}else{
	        					var tempArray=JSON.parse(that.goodsBo.attrValue.deliveryType);
			 					if(tempArray!=undefined&&tempArray!=null&&tempArray.length>0){
			 						that.$set(that.goodsBo,'deliveryType',tempArray[0]);
			 						for(var i=0;i<tempArray.length;i++){
			 							var deliveryObj={"typeCode":tempArray[i],"typeName":getValueFromMap(ret.data.enumDeliveryType,tempArray[i])};
			 							typeArray.push(deliveryObj);
			 						}
			 					}
	        				}
			 				that.$set(that.goodsBo,'deliveryTypeArray',typeArray);
			 			}
	        			var imgSmall = ret.data.goods.imgSmall;// 图片
	                    if(imgSmall.indexOf(";")!=-1){
	                    	imgSmall=imgSmall.split(";")[0];
	                    }
	                    that.goodsBo.imgSmall = getImgUrl()+"/upload/show.htm?filePath="+imgSmall;
	                    if(that.goodsBo.seckillPrice>0){
	                    	that.goodsBo.unitPrice = that.goodsBo.seckillPrice /100;
	                    	that.seckillPrice = that.goodsBo.seckillPrice;
	                    }else{
	                    	that.goodsBo.unitPrice = that.goodsBo.unitPrice /100;
	                    }
	                    if(that.goodsBo.attrValue.printService==null){
	                    	that.goodsBo.attrValue.printService=0;
	                    }else{
	                    	that.goodsBo.attrValue.printService=that.goodsBo.attrValue.printService/100;
	                    }
	                    
	                    that.goodsBo.goodsNumber = payNum;
						that.goodsBo.ext1 = that.goodsBo.unitPrice * payNum;
						that.goodsBo.ext2 = "noCart";
						that.goodsBo.ext3= shopCode;
						that.goodsBo.shopCode= shopCode;
						that.goodsBo.shopName= shopName;
						that.goodsBo.shopNameEn= shopNameEn;

						if(that.specName!=undefined&&that.specName!=''){
							that.goodsBo.goodsNameEn=that.goodsBo.goodsNameEn;
							that.goodsBo.specName=that.specName;
							that.goodsBo.specNameEn=that.specNameEn;
						}
						that.boList.push(that.goodsBo);

						that.points = ret.data.points;
						if(typeof(that.points)!='undefined'&&that.points!='undefined'&&that.points!=null&&that.points!=''){
							that.pointNum=that.points.point.usableNum;
							that.pointDiscount=that.points.point.discountMoney;
						}
						
						that.sortByShop();
						//计算运费
						that.computeExpressFee();
        			}
        		});
        	},
        	//按照店铺分类
	        sortByShop:function(){
	        	var that = this;
	        	var bos = that.boList;
	        	var shopBoMap = {};
	        	for(var i =0; i<bos.length;i++){
			 		//按照店铺分类
			 		var shopBo = shopBoMap[bos[i].shopNameEn];
			 		if(shopBo==undefined){
			 			var arrayTemp = new Array();
			 			arrayTemp.push(bos[i]);
			 			shopBo={
			 				shopNameEn:bos[i].shopNameEn,
			 				shopCode:bos[i].shopCode,
			 				expressFee:0,
			 				boListIn:arrayTemp
			 			}
			 			shopBoMap[bos[i].shopNameEn]= shopBo;
			 		}else{
			 			shopBo.boListIn.push(bos[i]);
			 		}
						if(bos[i].goodsPrice>0 && bos[i].pointType=='point'){
							that.goodsTotalPrice.totalPoint = bos[i].goodsPrice * bos[i].goodsNumber+that.goodsTotalPrice.totalPoint;
							//jQuery("#totalPoint").html(that.goodsTotalPrice.totalPoint+"通用积分");
						}
						if(bos[i].goodsPrice>0 && bos[i].pointType=='red'){
							that.goodsTotalPrice.totalRed = bos[i].goodsPrice * bos[i].goodsNumber+that.goodsTotalPrice.totalRed;
							//alert(1);
							//jQuery("#totalRed").html(that.goodsTotalPrice.totalRed+"红积分+");
							//console.log(jQuery("#totalRed").html());
						}
						if(bos[i].goodsPrice>0 && bos[i].pointType=='blue'){
							that.goodsTotalPrice.totalBlue = bos[i].goodsPrice * bos[i].goodsNumber+that.goodsTotalPrice.totalBlue;
							//jQuery("#totalBlue").html(that.goodsTotalPrice.totalBlue+"蓝积分+");
						}
						if(bos[i].goodsPrice>0 && bos[i].pointType=='special'){
							that.goodsTotalPrice.totalSpecial = bos[i].goodsPrice * bos[i].goodsNumber+that.goodsTotalPrice.totalSpecial;
							//jQuery("#totalSpecial").html(that.goodsTotalPrice.totalSpecial+"专用积分+");
						}
			 		//
	        	}

			 	for(var j in shopBoMap){
			 		that.shopBoList.push(shopBoMap[j]);
			 	}
	        },
	        //计算运费
	        computeExpressFee:function(){
	        	var that = this;
	        	var bos = that.boList;
				var goodOrder = "";
				var orderSource = that.orderSource;
				if(orderSource != "noCart"){
					orderSource = "cart";
				}
				var bos = that.boList;
				if(0==bos){
					return;
				}
				for(var i=0;i<bos.length;i++){
					if(i>0){
						goodOrder+=",";
					}
					if(bos[i].ext2 =="noCart"){	//
						bos[i].shopCode = bos[i].ext3;
						goodOrder = bos[i].goodsCode+":"+bos[i].goodsNumber+":"+bos[i].shopCode+":"+bos[i].specName+":"+bos[i].deliveryType;
					}else{
						goodOrder += bos[i].goodsCode+":"+bos[i].goodsNumber+":"+bos[i].id+":"+bos[i].shopCode+":"+bos[i].specName+":"+bos[i].deliveryType;
					}
				}
				if(that.specName!=undefined&&that.specName!=''){
					var specName=encodeURI(that.specName);
					goodOrder=goodOrder+":"+specName;
				}else{
					goodOrder=goodOrder+":"+null;
				}
	        	var addressId=that.addressId;
        		API.computeExpressFee(addressId,goodOrder,orderSource,function(ret){
        			if(ret.code == "success"){
        				that.totalExpressAmount = 0;
        				for(var i=0; i<that.shopBoList.length;i++){
        					var shopCode =that.shopBoList[i].shopCode;
        					var expressFee = ret.data[shopCode];
        					if(undefined ==expressFee || null==expressFee ){
        						expressFee=0;
        					}
        					that.shopBoList[i].expressFee=expressFee;
        					that.totalExpressAmount=that.totalExpressAmount+expressFee;
        					/*that.brokerDiscountPersent = ret.data["brokerDiscountPersent"];
        					if(that.seckillPrice==undefined||that.seckillPrice==''){
        						that.brokerDiscountAmount=that.sumOrderAmount*(100-that.brokerDiscountPersent);
        						if(that.brokerDiscountAmount>0){
        							that.discountType = "broker_level";
									that.discountAmount = that.brokerDiscountAmount/100;
        						}
        					}*/

        				}
        			}
        		});
	        },
	        getPointAddress: function() {
				var that = this;
					API.getUserAddress(function(ret) {
						if(ret.data != null) {
							that.addressBo=ret.data.addressBo;
							var addr = that.addressBo.province + that.addressBo.city + that.addressBo.district + that.addressBo.address;
							var ci = encodeURI(that.addressBo.city);
							that.initMap(addr,ci);
						}
					});
			},
        	getStoreList:function(BMap,map,pointStr,ci){
        		var that = this;
        		API.getStoreList(pointStr,ci,function(ret){
        			var storeInfoBoList = ret.data;
        			console.log(storeInfoBoList);
        			var data_info = new Array();
	      			if(storeInfoBoList != undefined && storeInfoBoList.length > 0){
	      				for(var i=0;i<storeInfoBoList.length;i++){
	      					var addr = storeInfoBoList[i].province + storeInfoBoList[i].city + storeInfoBoList[i].district + storeInfoBoList[i].address;
	      					var arr = new Array(storeInfoBoList[i].longitude, storeInfoBoList[i].latitude,
	      						storeInfoBoList[i].storeName + "<br>地址： " + addr + "<br>电话： " + storeInfoBoList[i].phone);
	      					data_info.push(arr);
	      				}
	      			}
	      			var opts = {
						width : 250,     // 信息窗口宽度
						height: 120,     // 信息窗口高度
						title : "Store details" , // 信息窗口标题
						enableMessage:true//设置允许信息窗发送短息
				   	};
				    for(var i=0;i<data_info.length;i++){
				    	var point = new BMap.Point(data_info[i][0],data_info[i][1]);
						var markers = new BMap.Marker(point, {
			        	  icon: new BMap.Symbol(BMap_Symbol_SHAPE_POINT, {
			        	    scale: 1,
			        	    fillColor: "red",
			        	    fillOpacity: 0.9,
			        	  })
			        	});
						map.addOverlay(markers);
						var content = data_info[i][2];
						addClickHandler(content,markers);
					}
				    function addClickHandler(content,marker){
						marker.addEventListener("click",function(e){
							showInfo(content,e)}
						);
					}
					function showInfo(content,e) {
						var p = e.target;
						var point = new BMap.Point(p.getPosition().lng, p.getPosition().lat);
						var infoWindow = new BMap.InfoWindow(content,opts);
						map.openInfoWindow(infoWindow,point);
					}
        		});
        	},
        	initMap:function(addr,ci){
        		var that = this;
        		var script = document.getElementById("mapScriptId");
        		if(script == null){
				that.$nextTick(function(){
			            MP(ak).then(BMap => {
			        		that.init_map(addr,ci);
			            });
					})
        		}else{
        			that.init_map(addr,ci);
        		}
        	},

        	init:function(){
        		var that = this;
        		var script = document.getElementById("mapScriptId");
        		if(script == null){
				that.$nextTick(function(){
			            MP(ak).then(BMap => {
			            });
					})
        		}
        	},
        	init_map:function(addr,ci){
        		var that = this;
        		var map = new BMap.Map("mapPage", {minZoom:7,maxZoom:17});
	            map.centerAndZoom(new BMap.Point(116.4035,39.915), 15);
	            //map.enableScrollWheelZoom();
	            map.addControl(new BMap.ScaleControl({anchor:BMAP_ANCHOR_BOTTOM_LEFT}));
	            map.addControl(new BMap.NavigationControl({type:BMAP_NAVIGATION_CONTROL_LARGE,anchor:BMAP_ANCHOR_BOTTOM_LEFT}));
	            map.addEventListener("dragend",function(){
					var bounds = map.getBounds();
					var sw = bounds.getSouthWest();
					var ne = bounds.getNorthEast();
					var pointStr = sw.lng + "," + sw.lat + "," + ne.lng + "," + ne.lat;
					that.getStoreList(BMap,map,pointStr,'');
				});//停止拖拽地图时触发
	            map.addEventListener("zoomend",function(){
					var bounds = map.getBounds();
					var sw = bounds.getSouthWest();
					var ne = bounds.getNorthEast();
					var pointStr = sw.lng + "," + sw.lat + "," + ne.lng + "," + ne.lat;
					that.getStoreList(BMap,map,pointStr,'');
				});//停止拖拽地图时触发
				var myGeo = new BMap.Geocoder();
			    myGeo.getPoint(addr, function(point){
				  if (point) {
				    var map = that.map;
					map.centerAndZoom(point, 15);
			        var marker = new BMap.Marker(point, {
		        	  icon: new BMap.Symbol(BMap_Symbol_SHAPE_POINT, {
		        	    scale: 1,
		        	    fillColor: "blue",
		        	    fillOpacity: 0.9,
		        	    strokeColor: "blue",
		        	    strokeOpacity: 0.3,
		        	    strokeWeight:20
		        	  })
		        	});
			        map.addOverlay(marker);
				  }
				}, "全国");
				that.getStoreList(BMap,map,'',ci);
	            this.map = map;
        	},
        	showMap:function(){
				//alert(this.deliveryTypeFag);
				this.deliveryTypeFag=0;
				var bos = this.boList;
				if(bos.length>0){
					for(var i=0;i<bos.length;i++){
						//alert("dielivery:"+bos[i].deliveryType);
						if(bos[i].deliveryType=='self_take'){
							this.deliveryTypeFag=1;
						}
					}
				}
				if(this.deliveryTypeFag==1){
					jQuery("#nearbyCompanyMap").show();
					//根据收货地址描点
					this.selectAddressPoint();
				}else{
					jQuery("#nearbyCompanyMap").hide();
				}
        	},
        	selectAddressPoint:function(){
				if(this.addressBoList.length>0 && this.deliveryTypeFag>0){
					var addressBo=this.addressBoList[this.indexFag];
					var addr = addressBo.province + addressBo.city + addressBo.district + addressBo.address;
					var ci = encodeURI(addressBo.city);
					this.initMap(addr,ci);
				}
        	},
			//发票弹窗
			showmodal: function() {
				var that = this;
				API.getReceiptList(function(ret) {
					if(ret.code == "success") {
						that.enterpriseList = ret.data.enterpriseList;
						that.specialList = ret.data.specialList;
					} else {
						MessageBox.alert("获取个人发票信息失败!", "提示");
					}
				});
				jQuery("#mainId").show();
				jQuery(".ui-mask").show();
			},
			//关闭发票弹窗
			closemodal: function() {
				jQuery("#mainId").hide();
				jQuery(".ui-mask").hide();
			},
			//企业发票
			change2: function() {
				jQuery("#click_2").addClass("tab-item-selected");
				jQuery("#click_3").removeClass("tab-item-selected");
				jQuery("#vat-inv").hide();
				jQuery("#ele-inv").show();
				this.receiptType = "2";
			},
			//增值税发票
			change3: function() {
				jQuery("#click_2").removeClass("tab-item-selected");
				jQuery("#click_3").addClass("tab-item-selected");
				jQuery("#ele-inv").hide();
				jQuery("#vat-inv").show();
				this.receiptType = "3";
			},
			//企业发票是否开票
			contentTab1: function() {
				jQuery("#electro-invoice-content-2").removeClass("invoice-item-selected");
				jQuery("#electro-invoice-content-1").addClass("invoice-item-selected");
				jQuery("#receiptContent").hide();
				this.isReceipt = 0;
			},
			//企业发票是否开票
			contentTab2: function() {
				jQuery("#electro-invoice-content-1").removeClass("invoice-item-selected");
				jQuery("#electro-invoice-content-2").addClass("invoice-item-selected");
				jQuery("#receiptContent").show();
				this.isReceipt = 1;
			},
			//企业发票选择
			selectTitle: function(event, titlenum, taxpayerNum) {
				if(titlenum < 0) {
					jQuery("#ele_code_div").hide();
					this.receiptType = '1';
				} else if(titlenum > 0) {
					jQuery("#ele_code_div").show();
					jQuery("#addEnterpriseRecipes").show();
					jQuery("#newReceiptTitle").hide();
					this.receiptType = '2';
				} else {
					jQuery("#addEnterpriseRecipes").hide();
					this.receiptType = '2';
				}
				jQuery("#ele_code").val(taxpayerNum);
				jQuery(".rise").removeClass("invoice-item-selected");
				jQuery(event.currentTarget).addClass("invoice-item-selected");
				this.receiptId = titlenum;
			},
			//增值税发票选择
			selectTitle1: function(event, titlenum, taxpayerNum, address, phone, openBank, openBankAccount) {
				if(titlenum < 0) {
					jQuery("#vat-inv-type1").hide();
					this.isReceipt1 = 0;
				} else if(titlenum > 0) {
					jQuery("#vat-inv-type1").show();
					jQuery("#addEnterpriseRecipes1").show();
					jQuery("#newReceiptTitle1").hide();
					this.receiptType = '3';
					this.isReceipt1 = 1;
				} else {
					jQuery("#addEnterpriseRecipes1").hide();
					this.receiptType = '3';
					this.isReceipt1 = 1;
				}
				if(titlenum > 0) {
					jQuery("#vat_code").val(taxpayerNum);
					jQuery("#vat_address").val(address);
					jQuery("#vat_phone").val(phone);
					jQuery("#vat_bankName").val(openBank);
					jQuery("#vat_bankAccount").val(openBankAccount);
				}
				jQuery(".rise1").removeClass("invoice-item-selected");
				jQuery(event.currentTarget).addClass("invoice-item-selected");
				this.receiptId1 = titlenum;
			},
			//保存企业发票
			saveReceipt: function() {
				var that = this;
				var receiptTitle = jQuery('#invoice-tit-list_lest').children('.invoice-item-selected').children('#invoice-2').children('input').val();
				var taxpayerNum = jQuery("#ele_code").val();
				var id = that.receiptId;
				var isReceipt = that.isReceipt;
				var receiptType = that.receiptType;
				if(receiptType == 2) {
					var reg_number = /^([a-zA-Z0-9]){15,20}$/;
					if(!reg_number.test(taxpayerNum)) {
						alert('请填写准确的纳税人识别号或统一社会信用代码!');
						jQuery("#ele_code").val('').focus();
						return false;
					}
					if(receiptTitle == null || receiptTitle == '') {
						alert("请填写准确发票抬头!", "提示");
						return false;
					}
					API.saveReceipt(id, receiptType, receiptTitle, taxpayerNum, null, null, null, null, function(ret) {
						if(ret.code == "success") {
							if(isReceipt == 1) {
								that.receiptSmall1 = '企业发票';
								that.receiptSmall2 = receiptTitle;
								that.receiptSmall3 = '商品明细';
								jQuery("#receiptSmall2").show();
								jQuery("#receiptSmall3").show();
								that.isReceiptTrue = 1;
							} else {
								that.receiptSmall1 = '不开发票';
								jQuery("#receiptSmall2").hide();
								jQuery("#receiptSmall3").hide();
								that.isReceiptTrue = 0;
							}
							that.receiptId = ret.data;
						} else {
							alert(ret.msg, "提示");
						}
					});
				} else if(receiptType == 1) {
					if(isReceipt == 1) {
						that.receiptSmall1 = '普通发票';
						that.receiptSmall2 = '个人';
						that.receiptSmall3 = '商品明细';
						jQuery("#receiptSmall2").show();
						jQuery("#receiptSmall3").show();
						that.isReceiptTrue = -1;
						that.receiptId = -1
					} else {
						that.receiptSmall1 = '不开发票';
						jQuery("#receiptSmall2").hide();
						jQuery("#receiptSmall3").hide();
						that.isReceiptTrue = 0;
					}

				}
				this.closemodal();
			},
			//新增企业发票
			addEnterprise: function() {
				jQuery(".rise").removeClass("invoice-item-selected");
				jQuery("#newReceiptTitle").addClass('invoice-item-selected').show().find('input').val('').focus();
				document.getElementById('invoice-tit-list_lest').scrollTop = document.getElementById('invoice-tit-list_lest').scrollHeight;
				jQuery("#ele_code_div").show();
				jQuery("#ele_code").val('');
				jQuery("#addEnterpriseRecipes").hide();
			},
			//新增增值税发票
			addEnterprise1: function() {
				jQuery(".rise1").removeClass("invoice-item-selected");
				jQuery("#newReceiptTitle1").addClass('invoice-item-selected').show().find('input').val('').focus();
				document.getElementById('invoice-tit-list_lest1').scrollTop = document.getElementById('invoice-tit-list_lest1').scrollHeight;
				jQuery("#vat_code").val("");
				jQuery("#vat_address").val("");
				jQuery("#vat_phone").val("");
				jQuery("#vat_bankName").val("");
				jQuery("#vat_bankAccount").val("");
				jQuery("#vat-inv-type1").show();
				jQuery("#addEnterpriseRecipes1").hide();
			},
			//保存增值税发票
			saveReceipt1: function() {
				var that = this;
				var receiptTitle = jQuery('#invoice-tit-list_lest1').children('.invoice-item-selected').children('#invoice-2').children('input').val();
				var taxpayerNum = jQuery("#vat_code").val();
				var address = jQuery("#vat_address").val();
				var phone = jQuery("#vat_phone").val();
				var openBank = jQuery("#vat_bankName").val();
				var openBankAccount = jQuery("#vat_bankAccount").val();
				var id = that.receiptId1;
				var receiptType = that.receiptType;

				if(that.isReceipt1 == 1) {
					var checkAddValed = true;
					// 增值税单位名称验证
					if(!that.check_Invoice1("vat_companyName", receiptTitle)) {
						checkAddValed = false;
					}
					// 增值税纳税人识别号验证
					if(!that.check_Invoice1("vat_code", taxpayerNum)) {
						checkAddValed = false;
					}
					// 增值税注册注册地址验证
					if(!that.check_Invoice1("vat_address", address)) {
						checkAddValed = false;
					}
					// 增值税注册电话验证
					if(!that.check_Invoice1("vat_phone", phone)) {
						checkAddValed = false;
					}
					// 增值税开户银行验证
					if(!that.check_Invoice1("vat_bankName", openBank)) {
						checkAddValed = false;
					}
					// 增值税开户银行账户验证
					if(!that.check_Invoice1("vat_bankAccount", openBankAccount)) {
						checkAddValed = false;
					}
					if(!checkAddValed) {
						return false;
					}
					API.saveReceipt(id, receiptType, receiptTitle, taxpayerNum, address, phone, openBank, openBankAccount, function(ret) {
						if(ret.code == "success") {
							that.receiptSmall1 = '增值税专用发票';
							that.receiptSmall2 = receiptTitle;
							that.receiptSmall3 = '商品明细';
							jQuery("#receiptSmall2").show();
							jQuery("#receiptSmall3").show();
							that.receiptId1 = ret.data;
							that.isReceiptTrue = 1;
						} else {
							alert(ret.msg, "提示");
						}
					});
				} else {
					that.receiptSmall1 = '不开发票';
					jQuery("#receiptSmall2").hide();
					jQuery("#receiptSmall3").hide();
					that.isReceiptTrue = 0;
				}
				this.closemodal();

			},
			check_Invoice: function(type, event) {
				var that = this;
				var errorFlag = false;
				var errorMessage = null;
				var value = event.target.value;
				// 验证发票单位名称
				if(type == "vat_companyName") {
					if(this.isEmpty(value)) {
						errorFlag = true;
						errorMessage = "单位名称不能为空！";
					} 
//					else {
//						if(this.checkLength(value) < 2) {
//							errorFlag = true;
//							errorMessage = "请填写完整单位名称！";
//						}
//						if(this.checkLength(value) > 50) {
//							errorFlag = true;
//							errorMessage = "单位名称过长,请重新输入！";
//						}
//						if(!this.is_forbidForInvoice(value)) {
//							errorFlag = true;
//							errorMessage = "单位名称含有非法字符！";
//						}
//					}
				} else if(type == "vat_code") { // 验证纳税人识别号
					if(this.isEmpty(value)) {
						errorFlag = true;
						errorMessage = "纳税人识别号不能为空！";
					} else {
						var reg_number = /^([a-zA-Z0-9]){15,20}$/;
						if(!reg_number.test(value)) {
							errorFlag = true;
							errorMessage = "纳税人识别号错误，请检查！";
						}
					}
				} else if(type == "vat_address") { // 验证发票注册地址
					if(this.isEmpty(value)) {
						errorFlag = true;
						errorMessage = "注册地址不能为空！";
					} else {
						if(this.checkLength(value) > 50) {
							errorFlag = true;
							errorMessage = "注册地址过长，请重新输入！";
						}
						if(!this.is_forbidForInvoice(value)) {
							errorFlag = true;
							errorMessage = "注册地址含有非法字符！";
						}
					}
				} else if(type == "vat_phone") { // 验证增值税发票电话
					if(this.isEmpty(value)) {
						errorFlag = true;
						errorMessage = "注册电话不能为空！";
					} else {
						if(this.checkLength(value) > 50) {
							errorFlag = true;
							errorMessage = "注册电话过长，请重新输入！";
						}
						if(!this.is_forbidForInvoice(value)) {
							errorFlag = true;
							errorMessage = "注册电话含有非法字符！";
						}
					}
				} else if(type == "vat_bankName") { // 验证增值税发票开户银行
					if(this.isEmpty(value)) {
						errorFlag = true;
						errorMessage = "开户银行不能为空！";
					} else {
						if(this.checkLength(value) > 50) {
							errorFlag = true;
							errorMessage = "开户银行过长，请重新输入！";
						}
						if(!this.is_forbidForInvoice(value)) {
							errorFlag = true;
							errorMessage = "开户银行含有非法字符！";
						}
					}
				} else if(type == "vat_bankAccount") { // 验证增值税发票银行账户
					if(this.isEmpty(value)) {
						errorFlag = true;
						errorMessage = "银行帐户不能为空！";
					} else {
						if(!this.is_forbidForInvoice(value)) {
							errorFlag = true;
							errorMessage = "银行帐户含有非法字符！";
						}
					}
				}
				if(errorFlag) {
					jQuery("#" + type + "_error").html(errorMessage);
					jQuery("#" + type + "_error").removeClass("succ-msg");
					jQuery("#" + type + "_error").addClass("error-msg");
					return false;
				} else {
					jQuery("#" + type + "_error").removeClass("error-msg");
					jQuery("#" + type + "_error").addClass("succ-msg");
					jQuery("#" + type + "_error").html("");

				}
				return true;
			},
			//我是真的不知道vue怎么能兼容,只能复制一个了
			check_Invoice1: function(type, value) {
				var that = this;
				var errorFlag = false;
				var errorMessage = null;
				// 验证发票单位名称
				if(type == "vat_companyName") {
					if(this.isEmpty(value)) {
						errorFlag = true;
						errorMessage = "单位名称不能为空！";
					} else {
						if(this.checkLength(value) < 2) {
							errorFlag = true;
							errorMessage = "请填写完整单位名称！";
						}
						if(this.checkLength(value) > 50) {
							errorFlag = true;
							errorMessage = "单位名称过长,请重新输入！";
						}
						if(!this.is_forbidForInvoice(value)) {
							errorFlag = true;
							errorMessage = "单位名称含有非法字符！";
						}
					}
				} else if(type == "vat_code") { // 验证纳税人识别号
					if(this.isEmpty(value)) {
						errorFlag = true;
						errorMessage = "纳税人识别号不能为空！";
					} else {
						var reg_number = /^([a-zA-Z0-9]){15,20}$/;
						if(!reg_number.test(value)) {
							errorFlag = true;
							errorMessage = "纳税人识别号错误，请检查！";
						}
					}
				} else if(type == "vat_address") { // 验证发票注册地址
					if(this.isEmpty(value)) {
						errorFlag = true;
						errorMessage = "注册地址不能为空！";
					} else {
						if(this.checkLength(value) > 50) {
							errorFlag = true;
							errorMessage = "注册地址过长，请重新输入！";
						}
						if(!this.is_forbidForInvoice(value)) {
							errorFlag = true;
							errorMessage = "注册地址含有非法字符！";
						}
					}
				} else if(type == "vat_phone") { // 验证增值税发票电话
					if(this.isEmpty(value)) {
						errorFlag = true;
						errorMessage = "注册电话不能为空！";
					} else {
						if(this.checkLength(value) > 50) {
							errorFlag = true;
							errorMessage = "注册电话过长，请重新输入！";
						}
						if(!this.is_forbidForInvoice(value)) {
							errorFlag = true;
							errorMessage = "注册电话含有非法字符！";
						}
					}
				} else if(type == "vat_bankName") { // 验证增值税发票开户银行
					if(this.isEmpty(value)) {
						errorFlag = true;
						errorMessage = "开户银行不能为空！";
					} else {
						if(this.checkLength(value) > 50) {
							errorFlag = true;
							errorMessage = "开户银行过长，请重新输入！";
						}
						if(!this.is_forbidForInvoice(value)) {
							errorFlag = true;
							errorMessage = "开户银行含有非法字符！";
						}
					}
				} else if(type == "vat_bankAccount") { // 验证增值税发票银行账户
					if(this.isEmpty(value)) {
						errorFlag = true;
						errorMessage = "银行帐户不能为空！";
					} else {
						if(!this.is_forbidForInvoice(value)) {
							errorFlag = true;
							errorMessage = "银行帐户含有非法字符！";
						}
					}
				}
				if(errorFlag) {
					jQuery("#" + type + "_error").html(errorMessage);
					jQuery("#" + type + "_error").removeClass("succ-msg");
					jQuery("#" + type + "_error").addClass("error-msg");
					return false;
				} else {
					jQuery("#" + type + "_error").removeClass("error-msg");
					jQuery("#" + type + "_error").addClass("succ-msg");
					jQuery("#" + type + "_error").html("");

				}
				return true;
			},
			isEmpty: function(value) {
				if(value == null || value == "" || value == "undefined" || value == undefined || value == "null") {
					return true;
				} else {
					if($.trim(value) == "") {
						return true;
					}
					return false;
				}
			},
			checkLength: function(txtObj) {
				var val = txtObj;
				var valLength = 0;
				for(var ii = 0; ii < val.length; ii++) {
					var word = val.substring(ii, 1);
					if(/[^\x00-\xff]/g.test(word)) {
						valLength += 2;
					} else {
						valLength++;
					}
				}
				return valLength;
			},
			is_forbidForInvoice: function(temp_str) {
				temp_str = temp_str.replace(/(^\s*)|(\s*$)/g, "");
				var forbid_str = new String('>,<,&');
				var forbid_array = new Array();
				forbid_array = forbid_str.split(',');
				for(var i = 0; i < forbid_array.length; i++) {
					if(temp_str.search(new RegExp(forbid_array[i])) != -1)
						return false;
				}
				return true;
			}

		},
		beforeMount: function() {
			var that = this;
			var deliveryMap = new Map();
			deliveryMap.set("express","快递收货");
			deliveryMap.set("self_take","上门自提");
			var goodsCode = this.$route.query.goodsCode;
			var payNum = this.$route.query.payNum;
			var shopCode = this.$route.query.shopCode;
			var shopName = this.$route.query.shopName;
			var shopNameEn = this.$route.query.shopNameEn;
			if(this.$route.query.orderType!=undefined&&this.$route.query.orderType!=null){
				that.orderType = this.$route.query.orderType;
			}
			if(this.$route.query.printServicePara!=undefined&&this.$route.query.printServicePara!=null&&this.$route.query.printServicePara!=''){
				that.printServicePara=parseInt(that.$route.query.printServicePara);//附件
			}
			if(this.$route.query.rebrandingServicePara!=undefined&&this.$route.query.rebrandingServicePara!=null&&this.$route.query.rebrandingServicePara!=''){
				that.rebrandingServicePara=parseInt(that.$route.query.rebrandingServicePara);//附件
			}
			if(this.$route.query.printingServicePara!=undefined&&this.$route.query.printingServicePara!=null&&this.$route.query.printingServicePara!=''){
				that.printingServicePara=parseInt(that.$route.query.printingServicePara);//附件
			}
			if(this.$route.query.laserServicePara!=undefined&&this.$route.query.laserServicePara!=null&&this.$route.query.laserServicePara!=''){
				that.laserServicePara=parseInt(that.$route.query.laserServicePara);//附件
			}
			if(this.$route.query.fileNamePara!=undefined&&this.$route.query.fileNamePara!=null){
				that.fileNamePara=that.$route.query.fileNamePara;//附件
			}
			if(this.$route.query.filePathPara!=undefined&&this.$route.query.filePathPara!=null){
				that.filePathPara=that.$route.query.filePathPara;//附件
			}
			if(this.$route.query.imageNamePara!=undefined&&this.$route.query.imageNamePara!=null){
				that.imageNamePara=that.$route.query.imageNamePara;//附件
			}
			if(this.$route.query.imagePathPara!=undefined&&this.$route.query.imagePathPara!=null){
				that.imagePathPara=that.$route.query.imagePathPara;//附件
			}
			that.payNum=payNum;
			that.goodsCode=goodsCode;
			that.shopCode=shopCode;
			if(typeof(this.$route.query.distributeAccount) !="undefined" && typeof(this.$route.query.distributeName) !="undefined" ){
				that.distributeAccount = this.$route.query.distributeAccount;
				that.distributeName = this.$route.query.distributeName;
			}
			if(typeof(this.$route.query.specName) !="undefined"){
				that.specName = this.$route.query.specName;
			}
			if(typeof(this.$route.query.specNameEn) !="undefined"){
				that.specNameEn = this.$route.query.specNameEn;
			}

			that.orderSource=this.$route.query.orderSource;
			if(typeof(goodsCode) == "undefined" || goodsCode == null  || typeof(payNum) == "undefined" || payNum == null){
				//that.boList = this.$route.query.bos;
				that.goodsCodes = this.$route.query.goodsCodes;
				var boList = JSON.parse(localStorage.getItem('bos'));
				if(boList != undefined && boList.length > 0){
					for(var i=0;i<boList.length;i++){
						boList[i].attrValue = JSON.parse(boList[i].attrValue);
        			if(boList[i].attrValue.deliveryType!=undefined&&boList[i].attrValue.deliveryType!=''){
        				var typeArray=new Array();
        				if(boList[i].attrValue.deliveryType.indexOf(",")==-1&&boList[i].attrValue.deliveryType.indexOf("[")==-1){
        					var deliveryObj={"typeCode":boList[i].attrValue.deliveryType,"typeName":deliveryMap.get(boList[i].attrValue.deliveryType)};
//      					deliveryObj.typeCode=boList[i].attrValue.deliveryType;
//		 					deliveryObj.typeName=deliveryMap.get(boList[i].attrValue.deliveryType);
		 					that.$set(boList[i],'deliveryTypeArray',new Array());
        					typeArray.push(deliveryObj);
//      					boList[i].deliveryType=boList[i].attrValue.deliveryType;
//      					Vue.set(boList[i],"deliveryType",boList[i].attrValue.deliveryType);
        					that.$set(boList[i],'deliveryType',boList[i].attrValue.deliveryType);
        				}else{
        					var tempArray=JSON.parse(boList[i].attrValue.deliveryType);
							//var tempArray=that.attrValue.deliveryType;
		 					if(tempArray!=undefined&&tempArray!=null&&tempArray.length>0){
//		 						boList[i].deliveryType=tempArray[0];
		 						//Vue.set(boList[i],"deliveryType",tempArray[0]);
		 						that.$set(boList[i],'deliveryType',tempArray[0]);

		 						for(var j=0;j<tempArray.length;j++){
		 							var deliveryObj={"typeCode":tempArray[j],"typeName":deliveryMap.get(tempArray[j])};
//		 							deliveryObj.typeCode=tempArray[i];
//		 							deliveryObj.typeName=deliveryMap.get(tempArray[i]);
//		 							Vue.set(boList[i],"deliveryTypeArray",[]);
		 							typeArray.push(deliveryObj);
		 						}
		 					}
        				}
		 				that.$set(boList[i],'deliveryTypeArray',typeArray);
		 			}
					}
					that.boList = boList;
				}
				that.sortByShop();
			}else{
				this.getOrderConfirm(goodsCode,payNum,shopCode,shopName,shopNameEn,that.specName);
			}
		},
		mounted() {
			 window.scrollTo(0, 0);
			this.getUserAddresses();
			this.showMap();
			this.init();

			this.getSumCount();
			this.getSumAmount();			
		},
		updated() {
			this.getSumCount();
			this.getSumAmount();
			$("input[name='addressChk']:checked").parent().parent().css("color","#fa660f");
		}
	}
</script>

<style>
.dt-jsz{
	margin-top: 7px;
	float: left;
	width: 45px;
	color: #999;
	text-align: right;
	color: #fa660f;
}

.bd .shop-name {
	margin:4px 20px;
	padding-left: 20px;
	height: 30px;
	line-height: 30px;
	background: #f9f8fa;
}
select {
    -webkit-appearance: menulist;
    box-sizing: border-box;
    align-items: center;
    white-space: pre;
    -webkit-rtl-ordering: logical;
    color: black;
    background-color: white;
    cursor: default;
    border-width: 1px;
    border-style: solid;
    border-image: initial;
    border-radius: 0px;
    border-color: rgb(169, 169, 169);
}
.mapPage{
    width: 100%;
    height: 450px;
    overflow: hidden;
    margin: 0;
    font-family: "微软雅黑";
}
</style>



// WEBPACK FOOTER //
// src/page/order/orderCommit.vue